import { ValueDataBind } from "./value";

/**
 * Data bind type for <input type="radio" />.
 */
export class RadioButtonDataBind extends ValueDataBind
{
    public attributeName = 'data-bind-radio';
    public selector = '[data-bind-radio]';
    public eventNames = ['change'];

    protected setElementValue(element: HTMLInputElement, value: any)
    {
        element.checked = value === element.value;
    }

    protected getElementValue(element: Element): any
    {
        return (element as HTMLInputElement).value;
    }
}